import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderRelatedTaxiDriver from "./billings-order-related-taxi-driver";
import BillingsOrderRelatedTaxiDriverParams from "./billings-order-related-taxi-driver-params";

const useBillingsOrderRelatedTaxiDriver = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderRelatedTaxiDriver>({
      data: [],
    });

  const load = async (
    params: BillingsOrderRelatedTaxiDriverParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiDriver = await billingService.getOrderRelatedTaxiDriverBillings(
        params,
        signal,
      );

      setData(taxiDriver);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderRelatedTaxiDriver;
